import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';

@Component({
  selector: 'app-profile-about',
  templateUrl: './profile-about.component.html',
  styleUrls: ['./profile-about.component.scss']
})
export class ProfileAboutComponent implements OnInit{

  @Input() showSpecialisationTypes:boolean=false;
  /* @Input() showSocialMediaHeading:boolean=false; */
  @Input() aboutYouForm!:FormGroup;

  @Input() endCustomerData:any;

  @Output() onUpdate:EventEmitter<any>=new EventEmitter();

  copyAboutForm:any;
  warningMessage:string='';
  isWordLimitExceeded :boolean=false;
  remainingWords: number = 255; 

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false, 
    showToolbar: false, 
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '', 
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [], 
    customClasses: [], 
    toolbarHiddenButtons: [],
    sanitize: false 
  };
  
specialisation=[];
  specialisations:any=[];
  showEditForm:boolean=false;

  specialityData:any=[];
  constructor(private endCustomerService:EndCustomerService) {}

  ngOnInit(): void {
    if (this.showSpecialisationTypes) {
      this.getSpecialities();
    }
    this.remainingWords = this.calculateRemainingWords(this.aboutId.get('about')?.value);
  
    this.aboutId.get('about')?.valueChanges.subscribe(value => {
      this.checkWordLimit(value);
      
    });
    ['facebookUrl', 'twitterUrl', 'linkedin', 'instagramUrl'].forEach(field => {      
      const control = this.aboutId.get(field);
      if (control) {
        control.setValidators([
          Validators.pattern('^(https:\/\/|http:\/\/|www\.).*'),
          Validators.maxLength(255)
        ]);
        control.updateValueAndValidity();
        
        control.valueChanges.subscribe((value: string) => {
          
          if (!value) return;
          const lowerCaseValue = value.toLowerCase().substring(0, 255);
          
          if (lowerCaseValue !== value) {
                  control.setValue(lowerCaseValue, { emitEvent: false });
                  control.updateValueAndValidity();
              }
          });
      }
  });
  
    this.aboutId.get('facebookUrl')?.valueChanges.subscribe((value: string) => {      
    this.aboutId.get('facebookUrl')?.setValue(value.toLowerCase(), { emitEvent: false });});
    this.aboutId.get('twitterUrl')?.valueChanges.subscribe((value: string) => {      
    this.aboutId.get('twitterUrl')?.setValue(value.toLowerCase(), { emitEvent: false });});
    this.aboutId.get('linkedin')?.valueChanges.subscribe((value: string) => {      
    this.aboutId.get('linkedin')?.setValue(value.toLowerCase(), { emitEvent: false });});
    this.aboutId.get('instagramUrl')?.valueChanges.subscribe((value: string) => {      
    this.aboutId.get('instagramUrl')?.setValue(value.toLowerCase(), { emitEvent: false });});
  }

  sanitizePaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData;
    let pastedHtml = clipboardData?.getData('text/html') || '';
    const pastedText = clipboardData?.getData('text/plain') || '';
    pastedHtml = pastedHtml.replace(/<img[^>]*>/g, '');
    document.execCommand('insertText', false, pastedHtml || pastedText);
  }
  
  calculateRemainingWords(value: string): number {
    const wordLimit = 255;
    const words = value ? value.trim().split(/\s+/) : [];
    return wordLimit - words.length;
  }
  
  checkWordLimit(value: string): void {
    const wordLimit = 255;
    const words = value ? value.trim().split(/\s+/) : [];
    this.remainingWords = this.calculateRemainingWords(value);
  
    if (words.length > wordLimit) {
      this.warningMessage = `Word limit of ${wordLimit} exceeded`;
      this.isWordLimitExceeded = true;
    } else {
      this.isWordLimitExceeded = false;
      this.warningMessage = '';
    }
  }
  

  cancel(){
    this.showEditForm=false;
    if(this.copyAboutForm?.aboutId ){
      if(this.copyAboutForm.aboutId && this.copyAboutForm.aboutId?.about){
        this.aboutId.get('about')?.patchValue(this.copyAboutForm.aboutId.about); 
      }else{
        this.aboutId.get('about')?.reset();
      }
      if(this.copyAboutForm.aboutId && this.copyAboutForm.aboutId?.facebookUrl){
        this.aboutId.get('facebookUrl')?.patchValue(this.copyAboutForm.aboutId.facebookUrl); 
      }else{
        this.aboutId.get('facebookUrl')?.reset();
      }
      if(this.copyAboutForm.aboutId && this.copyAboutForm.aboutId?.linkedin){
        this.aboutId.get('linkedin')?.patchValue(this.copyAboutForm.aboutId.linkedin); 
      }else{
        this.aboutId.get('linkedin')?.reset();
      }
      if(this.copyAboutForm.aboutId && this.copyAboutForm.aboutId?.twitterUrl){
        this.aboutId.get('twitterUrl')?.patchValue(this.copyAboutForm.aboutId.twitterUrl); 
      }else{
        this.aboutId.get('twitterUrl')?.reset();
      }
      if(this.copyAboutForm.aboutId && this.copyAboutForm.aboutId?.instagramUrl){
        this.aboutId.get('instagramUrl')?.patchValue(this.copyAboutForm.aboutId.instagramUrl); 
      }else{
        this.aboutId.get('instagramUrl')?.reset();
      }
    }else{
      this.aboutId.reset();
    }
   
    this.aboutYouForm.get('specialityInfos')?.patchValue(this.copyAboutForm?.specialityInfos); 
    this.getSpecialityData(); 
  }

  update(){
    this.aboutId.markAllAsTouched();
    if(this.aboutId.invalid || this.isWordLimitExceeded){
      return;
    }
    
    this.onUpdate.emit(10);
  }

  editAboutYou(){
    this.copyAboutForm=JSON.parse(JSON.stringify(this.aboutYouForm.value));
    this.showEditForm=true;
  }

  refresh(){
    this.showEditForm=false;
    if(this.showSpecialisationTypes){
      this.getSpecialityData();
    }
  }

  getSpecialities(){
    this.endCustomerService.executeGetRequestURL(MweConstants.specialtyUrl,null).subscribe(data=>{
      if(data && data?.data && data.data.length>0){
        this.specialisations=data.data;
        if(data && data?.data && data.data.length>0){
          this.getSpecialityData();
        }
      }
    },error=>{

    })
  }

  getSpecialityData(){  
    const speciality=this.specialisations;  
    const specialityInfos=speciality.filter((obj1:any)=>{
      return this.endCustomerData.specialityInfos.some((obj2:any)=>{
        return obj1.id===obj2.specialityInfoId;
      })
    })
    this.specialityData=specialityInfos;
  }
 
  remove(i:number): void {
    this.aboutYouForm.get('specialityInfos')?.value.splice(i,1);
    this.aboutYouForm.get('specialityInfos')?.patchValue(this.aboutYouForm.get('specialityInfos')?.value);
}

getSpecility(id:any){
  return this.specialisations.find((obj:any)=>obj?.id===id)?.name;
 }
get aboutId(){
  return this.aboutYouForm.controls['aboutId'] as FormGroup;
}

openUrl(url:any){
  if (!url.startsWith("http")) {
    url = `https://${url}`;
  }
  window.open(url, '_blank');
}
}